/**
 * Iconify 离线配置
 *
 * 导入本地图标集，避免运行时请求 api.iconify.design
 *
 * @author AI Assistant
 * @date 2025-10-21
 */

// 导入本地图标集 JSON 数据
import carbonIcons from '@iconify-json/carbon/icons.json';
import lucideIcons from '@iconify-json/lucide/icons.json';
import { addCollection } from '@iconify/vue';

/**
 * 初始化本地图标集
 * 将图标数据添加到 Iconify 缓存中，避免外部请求
 */
export function setupIconifyOffline() {
  // 添加 Carbon 图标集（项目主要使用）
  addCollection(carbonIcons);
  console.warn('✅ Carbon 图标集已加载（离线模式）');

  // 添加 Lucide 图标集
  addCollection(lucideIcons);
  console.warn('✅ Lucide 图标集已加载（离线模式）');
}
